export { UwcBox }       from './box/index.js';
export { UwcStack, UwcFlex } from './stack/index.js';
export { UwcGrid }      from './grid/index.js';
export { UwcContainer } from './container/index.js';

import { UwcBox }       from './box/index.js';
import { UwcStack, UwcFlex } from './stack/index.js';
import { UwcGrid }      from './grid/index.js';
import { UwcContainer } from './container/index.js';

customElements.define('uwc-box',       UwcBox);
customElements.define('uwc-stack',     UwcStack);
customElements.define('uwc-flex',      UwcFlex);
customElements.define('uwc-grid',      UwcGrid);
customElements.define('uwc-container', UwcContainer);
